import CartStore from './cart-store.js';
import CartDrawer from './cart-drawer.js';
import CartModal from './cart-notification-modal.js';

// Helper to determine cart behavior based on screen size
function getCartBehavior() {
  const settings = window.__AGENCY_CART?.settings || {};
  const isMobile = window.innerWidth < 768;
  return isMobile ? settings.cartBehaviorMobile : settings.cartBehaviorDesktop;
}

// Intercept clicks on cart links to open drawer instead
// This runs immediately, before Alpine initializes
function interceptCartLinks() {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/cart"]');
    if (link && link.href) {
      try {
        const url = new URL(link.href);
        // Only intercept if it's going to /cart (not /cart/add or other cart routes)
        if (url.pathname === '/cart' || url.pathname.endsWith('/cart')) {
          event.preventDefault();
          event.stopPropagation();
          // Open the drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          return false;
        }
      } catch (e) {
        // If URL parsing fails, check if href contains /cart
        if (link.href.includes('/cart') && !link.href.includes('/cart/add')) {
          event.preventDefault();
          event.stopPropagation();
          document.dispatchEvent(new CustomEvent('cart:open'));
          return false;
        }
      }
    }
  }, true); // Use capture phase to catch early
}

// Initialize cart link interception immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', interceptCartLinks);
} else {
  interceptCartLinks();
}

function registerCartModule() {
  // Register Global Store
  Alpine.store('cart', CartStore);

  // Register Component Logic
  Alpine.data('cartDrawer', CartDrawer);
  Alpine.data('cartModal', CartModal);

  // Listen for cart:item:added event (dispatched by ajax-product-forms.js and cart-store.js)
  // Handle based on cart behavior setting
  document.addEventListener('cart:item:added', async (event) => {
    const store = Alpine.store('cart');
    if (store) {
      // Refresh cart state from server
      await store.refreshCart();

      const behavior = getCartBehavior();

      switch (behavior) {
        case 'modal':
          // Open the modal with the added item
          document.dispatchEvent(new CustomEvent('cart:modal:open', {
            detail: event.detail
          }));
          break;
        case 'alert':
          // Simple browser alert (existing behavior)
          alert('Item added to cart!');
          break;
        case 'redirect':
          // Redirect to cart page
          window.location.href = '/cart';
          break;
        case 'drawer':
        default:
          // Open the drawer
          document.dispatchEvent(new CustomEvent('cart:open'));
          break;
      }
    }
  });
}

// Register on alpine:init event (fires when Alpine initializes)
document.addEventListener('alpine:init', registerCartModule);

// Fallback: If Alpine is already available, register immediately
if (window.Alpine) {
  registerCartModule();
}

